import React, { Component } from "react"
import { Link, graphql } from "gatsby"
import PropTypes from "prop-types"
import { Disqus, CommentCount } from 'gatsby-plugin-disqus'
import Layout from "../components/layout"

class Post extends Component {
  render() {
    const post = this.props.data.wordpressPost
    const edges = this.props.data.allWordpressPost.edges.filter( (edge) =>
		    edge.node.id === post.id ) 
    const next = edges ? edges[0].previous : ""
    const prev = edges ? edges[0].next : ""
    const Next = () => {
      return next ? <div>Next: <Link to={next.slug}>{next.title}</Link></div> : ""
    }
    const Prev = () => {
      return prev ? <div>Previous: <Link to={prev.slug}>{prev.title}</Link></div> : ""
    }
    const disqusConfig = {
      url: `${this.props.data.site.siteMetadata.siteUrl+post.slug}`,
      identifier: post.id,
      title: post.title,
    }
    return (
      <Layout>
        <h1>{post.title}</h1>
        <div dangerouslySetInnerHTML={{ __html: post.content }}></div>
	<Next/>
	<br />
	<Prev/>
	<br />
	<CommentCount config={disqusConfig} placeholder={'...'} />
        <Disqus config={disqusConfig} />
      </Layout>
    )
  }
}

Post.propTypes = {
  data: PropTypes.object.isRequired,
  edges: PropTypes.array,
}

export default Post

export const postQuery = graphql`
  query($id: String!) {
    wordpressPost(id: { eq: $id }) {
      id
      title
      content
    }
    site {
      siteMetadata {
        title
        subtitle
        author
	siteUrl
      }
    }
    allWordpressPost {
      edges {
        next {
          title
	  slug
        }
        previous {
          title
	  slug
        }
        node {
          id
        }
      }
    }
  }
`
